import Button from "presentation/components/Button/Button";
import styles from "../../FooterLinks/FooterLink.module.scss";
import { useNavigate } from "react-router-dom";

const OneLinkSolutionsPT = () => {

  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <div className={`${styles.popup} px-5 py-4 mb-2`}>
        <h1>O conceito 1link</h1>
        <p>As empresas sabem que actualmente já não é necesário realizar qrandes investimentos para desenvolver soluções de software próprios, às
          quais teriam que estar ligadas indefinidamente. A alternativa mais viável é a de partilhar plataformas comuns com outras empresas com
          necessidades similares, através de soluções locais. Aqui entra em cena a 1link, um conjunto de plataformas on-line utilizadas centralmente
          e desenhadas para facilitar a requisição de serviços da indústria automóvel através de tecnologias de fácil acesso.</p>

        <p>Ao oferecer plataformas completas de comércio electrónico, oferecemos aos nossos clientes a possibilidade de desfazer-se de processos
          complicados de coordenação de serviços que se desenvolvem em ambientes tecnológicos complicados. Através da mesma tecnologia utilizada
          nos cartões de crédito, consegue-se motivar a participação em um sistema comum de inúmeros clientes e fornecedores. O produto 1link
          opera de maneira semelhante, abrangendo as etapas mais críticas do peculiar ciclo de vida de um veículo de uma frota automóvel.</p>

        <p>A 1link é a verdadeira plataforma on-line, acessível através de qualquer conexão à Internet e criada para aceder ao mais avançado em
          tecnologia através de um mecanismo de baixo custo e pago consoante a sua utilização.</p>

        <p>Já standard no Reino Unido, a 1link está destinada a tornar-se a plataforma on-line de comércio electrónico standard no mercado automóvel
          europeu através da qual, as maiores frotas automóveis podem solicitar os seus produtos e serviços à sua rede de fornecedores, graças à criação
          de transações através da Internet. A 1link leva a uma redução considerável na gestão administrativa e incrementa a precisão do desempenho, ou
          seja, reduz os custos e incrementa a eficiência dos serviços consideravelmente.</p>

        <div className={`${styles.close} float-end mt-3`}>
          <Button label="OK" onClick={() => navigate("/")} />
        </div>
      </div>
    </div >
  )
}

export default OneLinkSolutionsPT;